import { createSelector } from 'reselect';

const getToast = ({ dialogToast }) => dialogToast.toast;

export const getModel = createSelector([
    getToast
], (
    toast
) => {
    return {
        toast
    };
});
